module.exports = __webpack_public_path__ + "static/media/WA_footy_lives_here_logo.614fc0f9.png";